export const PUBLIC_DISPLAY_NAME_MIN_LENGTH = 2;
export const PUBLIC_DISPLAY_NAME_MAX_LENGTH = 80;

export type PublicDisplayNameValidation =
  | { ok: true; value: string; input: string }
  | { ok: false; error: string; input: string };

export function normalizePublicDisplayName(value: string | null | undefined): string {
  return (value ?? '').replace(/\s+/g, ' ').trim();
}

export function validatePublicDisplayName(value: string): PublicDisplayNameValidation {
  const normalized = normalizePublicDisplayName(value);

  if (!normalized) {
    return {
      ok: false,
      error: 'Enter the name you want buyers and sellers to see.',
      input: value,
    };
  }

  if (normalized.length < PUBLIC_DISPLAY_NAME_MIN_LENGTH) {
    return {
      ok: false,
      error: 'Public name must be at least 2 characters.',
      input: value,
    };
  }

  if (normalized.length > PUBLIC_DISPLAY_NAME_MAX_LENGTH) {
    return {
      ok: false,
      error: 'Public name must be 80 characters or fewer.',
      input: value,
    };
  }

  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
    return {
      ok: false,
      error: 'Use a personal, business, or brand name—not an email address.',
      input: value,
    };
  }

  return { ok: true, value: normalized, input: value };
}

export function resolveInitialPublicDisplayName(
  existingProfileName: string | null | undefined,
  signupName: string | null | undefined,
): string {
  const existing = normalizePublicDisplayName(existingProfileName);
  if (existing) return existing;
  return normalizePublicDisplayName(signupName);
}
